module.exports = __webpack_public_path__ + "img/shome.2aecf30c.jpg";